__turbopack_context__.v({
  "search__result": "SearchResult-module-scss-module__4l0pTG__search__result",
});
